export default function TrainingAdministrationDirective() {
  return {
    template: require('./training-administration.directive.html'),
    controller: 'TrainingAdministrationDirectiveController',
    controllerAs: 'trainingAdminVM',
    bindToController: true,
    replace: true,
  };
}
